import { render, staticRenderFns } from "./portfolio_mobile.vue?vue&type=template&id=01643cbc&scoped=true&"
import script from "./portfolio_mobile.vue?vue&type=script&lang=js&"
export * from "./portfolio_mobile.vue?vue&type=script&lang=js&"
import style0 from "./portfolio_mobile.vue?vue&type=style&index=0&id=01643cbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01643cbc",
  null
  
)

export default component.exports